class ExtendableError extends Error {
  constructor(message){
    super(message);
    this.name = this.constructor.name;
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = (new Error(message)).stack;
    }
  }
}

export class NotFoundError extends ExtendableError {
  constructor(message){
    super(message);
    this.message = message || 'Entity not found';
    this.name = 'NotFoundError';
  }
}

export class AuthenticationError extends ExtendableError {
  constructor(message){
    super(message);
    this.message = message || 'Invalid Authentication Token';
    this.name = 'AuthenticationError';
  }
}

export class AuthorizationError extends ExtendableError {
  constructor(message){
    super(message);
    this.message = message || 'User is not authorized to make this request';
    this.name = 'AuthorizationError';
  }
}

export class ImpersonationError extends ExtendableError {
  constructor(message){
    super(message);
    this.message = message || 'Invalid Impersonation Token';
    this.name = 'ImpersonationError';
  }
}

export class RequestError extends ExtendableError {
  constructor(message){
    super(message);
    this.message = message || 'Invalid Request';
    this.name = 'RequestError';
  }
}

export class ServerError extends ExtendableError {
  constructor(message){
    super(message);
    this.message = message || 'Server Error';
    this.name = 'ServerError';
  }
}

export class TimeOutError extends ExtendableError {
  constructor(message){
    super(message);
    this.message = message || 'Server timed out';
    this.name = 'TimeOutError';
  }
}

export class ForbiddenError extends ExtendableError {
  constructor(message){
    super(message);
    this.message = message || 'Operation is forbidden';
    this.name = 'ForbiddenError';
  }
}



// WEBPACK FOOTER //
// ./src/shared/redux/errors/types.js